<template lang="pug">
	.creative-create-storyboard(v-if="showed")
		.card
			.card-header
				span Create storyboard creative
			.card-body.collapse.show
				.form-group.separator
					label.col-form-label Storyboard creative title
						.controls
							input.form-control.title(size="16" type="text" v-model="title" @keyup.enter="create()")
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" :class="{disabled: !title}" v-on:click="create()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	export default {
		name: "StoryboardCreateCreative",
		mixins: [Screen],
		screen: {
			events: {
				"Show StoryboardCreateCreative": function() {

					this.title = '';

				}
			}
		},
		data() {
			return {
				showed: false,
				title: ''
			};
		},
		methods: {
			collectData() {



			},
			close() {

				this.hide();

			},
			create() {

				if (!this.title) return;

				Server.sendToSocket({
					CreateCreative: {
						type: 'storyboard',
						title: this.title,
						workspace: Layout.workspace,
						publisherId: Publisher.SelectedPublisher.id
					}
				});

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.creative-create-storyboard
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 550px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 200px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.two-setting-panel
				display: flex
				flex-direction: row
				justify-content: space-between

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				justify-content: space-between

				.title
					display: flex
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					flex-direction: row
					align-items: baseline

					.icon-info
						color: #20a8d8
						margin-left: 5px
						font-size: 13px !important

				.form-control
					width: 350px

</style>
